import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import Valg from '../Shared/Scripts/Models/Valg';
import {SliderComponent} from './Components/SliderComponent';

import VeilederBetalingskalkulatorDto from './Models/VeilederBetalingskalkulatorDto';
import { VeilederBetalingskalkulatorAppState } from './Store';
import * as Ids from './Models/Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import ResultatComponent from './Components/ResultatComponent';
import {NedbetalingstidComponent} from './Components/NedbetalingstidComponent';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

interface AppState {
    collapsed: boolean
}

export class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {collapsed: true}
    }

    render(): JSX.Element {
        const { valg, dispatchUpdateValg, epiContext } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;
        let self = this;

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        function hentBreddeKlasse(): string {
            if(epiModel?.bredde === undefined || epiModel.bredde.value === "") {
                return "c-veileder c-veileder--mini";
            }
            return "c-veileder " + epiModel.bredde.value;
        }

        function visKalkulator(e: React.SyntheticEvent<HTMLButtonElement>): void {
            e.preventDefault();
            document.getElementById("c-veileder-betkalk-boks1-input")?.focus();

            if(valg.visHeleKalkulator) {
                dispatchUpdateValg({visHeleKalkulator: false});
                setDefaultValues();
                self.setState({collapsed: true});
            }
            else {
                dispatchUpdateValg({visHeleKalkulator: true});
                setDefaultValues();
                self.setState({collapsed: false});
            } 
        }

        function setDefaultValues() {
            if(valg.lanebelop === undefined) {
                if(epiModel?.defaultLaneBelop !== undefined) {
                    let value: string = epiModel?.defaultLaneBelop?.value;
                    let belop: Valg<string> = { id: '', displayValue: value, value: value }    
                    dispatchUpdateValg({lanebelop: belop});
                }
            }

            if(valg.rente === undefined) {
                if(epiModel?.satsFlytendeRente !== undefined) {
                    let value: string = epiModel?.satsFlytendeRente?.value;
                    let rente: Valg<string> = { id: '', displayValue: value, value: value }    
                    dispatchUpdateValg({rente: rente});
                }
            }

            if(valg.nedbetalingstidAar === undefined) {
                if(epiModel?.defaultAntallAar !== undefined) {
                    let value: number = parseInt(epiModel?.defaultAntallAar?.value);
                    let nedbetalingstid: number = value;
                    dispatchUpdateValg({nedbetalingstidAar: nedbetalingstid});
                }
            }

            if(valg.nedbetalingstidMaaneder === undefined) {
                if(epiModel?.defaultAntallAar !== undefined) {
                    let value: number = parseInt(epiModel?.defaultAntallAar?.value);
                    let nedbetalingstid: number = (value * 12) - 7;
                    dispatchUpdateValg({nedbetalingstidMaaneder: nedbetalingstid});
                }
            }
        }

        function hentEkspandertCss() {
            if(valg.visHeleKalkulator)
                return "c-veileder--mini-ekspandert";
            else 
                return "";
        }

        function hentLenker() {
            let lenker: JSX.Element[] = [];
            if(epiModel?.lenker !== undefined)
            {
                for(let i = 0;i<epiModel?.lenker.value.length;i++) {
                    let lenke: JSX.Element = <li key={i}>
                            <a className="c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine" href={epiModel?.lenker.value[i].href}>
                                {epiModel?.lenker.value[i].text}
                            </a>
                        </li>

                    lenker.push(lenke);
                }
            }
            return lenker;
        }

        function hentBunnPanel(): JSX.Element | null {
            
            if(epiModel?.lenker !== undefined && epiModel?.lenker?.value?.length > 0 ) {
                return <div className="c-veileder__panel">
                            <div className="c-veileder__content">
                                <h4 className="c-veileder-liste__panel-header">{contentResolver(epiContext, 'lenkerOverskrift')}</h4>
                                <ul className="c-veileder-liste__panel c-veileder-liste__panel--links">
                                    {hentLenker()}
                                </ul>
                            </div>
                        </div>
            }

            return null;
        }

        function hentGulSirkel(): JSX.Element | null {
            if(epiModel?.boks1GulSirkel === undefined || epiModel?.boks1GulSirkel.value === undefined || epiModel?.boks1GulSirkel.value === "")
                return null;

            return <div className="c-sirkel">{contentResolver(epiContext, 'boks1GulSirkel')}</div>;
        }

        function hentMaksNedtbetlingstid(tmpLanebelop: string | null = null): number {

            let lanebelop: number | undefined = undefined;

            if(valg.lanebelop !== undefined) {
                lanebelop = parseInt(valg.lanebelop.value);
            }

            if(tmpLanebelop !== null)
                lanebelop = parseInt(tmpLanebelop);

            if(lanebelop !== undefined) {

                let avdragsFrihet: number = 7;//fallback
                if(epiModel?.defaultAvdragsfrihet !== undefined && epiModel?.defaultAvdragsfrihet.value !== "") {
                    avdragsFrihet = parseInt(epiModel?.defaultAvdragsfrihet.value);
                }

                let terskelverdi: number = 261000;//fallback
                if(epiModel?.terskelverdi20ar !== undefined && epiModel?.terskelverdi20ar.value !== "") {
                    terskelverdi = parseInt(epiModel?.terskelverdi20ar.value);
                }

                let nedbetAntallAar: number = 20;//fallback
                if(epiModel?.defaultAntallAar !== undefined && epiModel?.defaultAntallAar.value !== "") {
                    nedbetAntallAar = parseInt(epiModel?.defaultAntallAar.value);
                }

                if(isNaN(lanebelop)) {
                    return (nedbetAntallAar * 12) - 7;
                }
                    

                if(lanebelop >= terskelverdi) { 
                    return (nedbetAntallAar * 12) - 7;
                } else {
                    let antallManeder: number = (lanebelop/terskelverdi)*((nedbetAntallAar*12)-avdragsFrihet) 
                    return antallManeder;
                }
            }

            return 233;
        }

        function hentMaksNedtbetlingstidAar(antallMaaneder: number): number {

            let antallAar: number = (antallMaaneder + 7) / 12;
            if(antallAar < 1) {
                return 1;
            }
            
            return Math.round(antallAar);
        }

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.visHeleKalkulator) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'Klikk', eventId });
                }
            }
        }

        if (epiModel != null) {
            registerEvents();
            return (
                <div className={hentBreddeKlasse()}>
                    <div className="c-veileder__panel c-veileder__panel--input-white c-veileder--skjul-trekant">
                        {hentGulSirkel()}
                        <div className="c-veileder__content c-veileder__content--header">
                            <h3 className="c-veileder__tittel">{contentResolver(epiContext, 'boks1Overskrift')}</h3>
                        </div>
                        <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented c-veileder--div-bigger-spacer">
                            <SliderComponent
                                id={'boks1'}
                                collapsed={false}
                                valg={valg.lanebelop}
                                label={contentResolver(epiContext, 'boks1BelopLedetekst')}
                                locale={locale}
                                value={epiContext.epiModel?.defaultLaneBelop.value}
                                maxInput={9999999}
                                minSlider={0}
                                minAllowInput={'1'}
                                posibleToSetZero={false}
                                formatNumber={true}
                                maxSlider={2000000}
                                sliderStep={5000}
                                valuta={valuta}
                                useDecimal={false}
                                onChangeHandler={(belop: Valg<string>): void => {
                                    //vi sender med beløpet til utretningen for tid siden beløpet ikke er satt i valg enda. det gjøres nedenfor.
                                    let nedbetMaaneder: number = hentMaksNedtbetlingstid(belop.value);
                                    if (nedbetMaaneder === 0 || isNaN(nedbetMaaneder)) {
                                        nedbetMaaneder = 1;
                                    }

                                    let nedbetAar: number = hentMaksNedtbetlingstidAar(nedbetMaaneder);
                                    dispatchUpdateValg({
                                        lanebelop: belop,
                                        nedbetalingstidAar: nedbetAar,
                                        nedbetalingstidMaaneder: nedbetMaaneder,
                                    });
                                }}
                            />
                        </div>
                        <div className={'c-veileder--mini-kollapset ' + hentEkspandertCss()}>
                            <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented">
                                <SliderComponent
                                    id={'boks2'}
                                    collapsed={this.state.collapsed}
                                    valg={valg.rente}
                                    label={contentResolver(epiContext, 'boks1RenteLedetekst')}
                                    locale={locale}
                                    value={epiContext.epiModel?.satsFlytendeRente.value}
                                    maxInput={9.999}
                                    minSlider={0}
                                    minAllowInput={'0.1'}
                                    posibleToSetZero={false}
                                    formatNumber={false}
                                    maxSlider={9.999}
                                    sliderStep={0.01}
                                    valuta={'%'}
                                    useDecimal={true}
                                    onChangeHandler={(rente: Valg<string>): void => {
                                        dispatchUpdateValg({ rente: rente });
                                    }}
                                />
                            </div>
                            <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented">
                                <NedbetalingstidComponent
                                    id={'boks3'}
                                    collapsed={this.state.collapsed}
                                    label={contentResolver(epiContext, 'boks1AntallAarLedetekst')}
                                    locale={locale}
                                    value={
                                        valg.nedbetalingstidAar === undefined
                                            ? '20'
                                            : valg.nedbetalingstidAar.toString()
                                    }
                                    maxInput={
                                        valg.nedbetalingstidAar === undefined
                                            ? 20
                                            : hentMaksNedtbetlingstidAar(hentMaksNedtbetlingstid())
                                    }
                                    minSlider={1}
                                    minAllowInput={'1'}
                                    posibleToSetZero={false}
                                    formatNumber={true}
                                    maxSlider={
                                        valg.nedbetalingstidAar === undefined
                                            ? 20
                                            : hentMaksNedtbetlingstidAar(hentMaksNedtbetlingstid())
                                    }
                                    sliderStep={1}
                                    valuta={epiContext.epiModel?.boks1AarLedetekst.value}
                                    onChangeHandler={(nedbetalingstid: number): void => {
                                        dispatchUpdateValg({
                                            nedbetalingstidAar: nedbetalingstid,
                                            nedbetalingstidMaaneder: nedbetalingstid * 12 - 7,
                                        });
                                    }}
                                    aarUnder1Melding={contentResolver(epiContext, 'boks1AarUnder1')}
                                />
                            </div>
                        </div>
                    </div>
                    {valg.visHeleKalkulator && (
                        <div className={'c-veileder--mini-kollapset ' + hentEkspandertCss()}>
                            <ResultatComponent valg={valg} locale={locale} valuta={valuta} eventId={eventId} />
                            {hentBunnPanel()}
                        </div>
                    )}
                    <div className="c-veileder--mini-knapp">
                        <button
                            onClick={visKalkulator}
                            className={`c-knapp c-knapp--cta-med-kun-ikon c-knapp--primary ${this.state.collapsed ? '' : 'c-knapp--opposite c-knapp--cta-med-kun-ikon-reversed'}`}
                            aria-expanded={this.state.collapsed ? 'false' : 'true'}
                        >
                            {contentResolver(
                                epiContext,
                                this.state.collapsed ? 'visKalkulatorTekst' : 'skjulKalkulatorTekst',
                            )}
                        </button>
                    </div>
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederBetalingskalkulatorDto>;
    resultat: ResultatValg;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederBetalingskalkulatorAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederBetalingskalkulatorAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
